import { useTheme } from "@emotion/react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip
} from "@mui/material";


export const StoreTable = ({ data }) => {
    console.log(data)
    const style = useTheme().palette;

    return (
        <TableContainer
            component={Paper}
            sx={{
                mt: 4,
                borderRadius: 3,
                boxShadow: 4
            }}
        >
            <Table>
                <TableHead sx={{ background: style.primary.main }}>
                    <TableRow>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>#</TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Product</TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Purchase</TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Sell</TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Qty</TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Stock Value</TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>User</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data && data.length > 0 ? (
                        data.map((item, index) => {

                            const profit = item.sell_Price - item.purchase_Price;
                            const totalValue = item.purchase_Price * item.quantity;

                            return (
                                <TableRow
                                    key={index}
                                    sx={{
                                        "&:hover": {
                                            backgroundColor: "#f5f5f5"
                                        },
                                        transition: "0.3s"
                                    }}
                                >
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{item.purchase_Price}</TableCell>
                                    <TableCell>{item.sell_Price}</TableCell>
                                    <TableCell>{item.quantity}</TableCell>

                                    <TableCell>
                                        {totalValue.toLocaleString()}
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={item.teacher_name}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <TableCell colSpan={8} align="center">
                                No Data Found
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
